import { Fragment, useEffect, useState, } from 'react';
import { useInView } from 'react-intersection-observer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useSetRecoilState } from 'recoil';
import translator from '@Components/Utilities/Translator';

const FooterView = (props) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        rootMargin: '1%',
    });
    const [iconClass, setIconClass] = useState('');
    const setShowCookieConsent = useSetRecoilState(atoms.showCookieConsent);

    useEffect(() => {
        if (inView) {
            setIconClass("lazyload-bg");
        }
    }, [inView]);

    const [status, setStatus] = useState({
        mobileOptionBar: false,
        detailContactBar: false
    });
    useEffect(() => {
        setStatus({
            mobileOptionBar: document.getElementsByClassName('mobile-option-bar').length > 0,
            detailContactBar: document.getElementsByClassName('detail-contact-bar').length > 0
        });
    }, []);

    const showCookieConsentModal = () => {
        setShowCookieConsent(true);
    }

    const getBottomPosition = () => {
        let bottom = 0;
        if (status.mobileOptionBar) {
            let mobileOptionBar = document.getElementsByClassName('mobile-option-bar')?.[0];
            if (mobileOptionBar) {
                bottom += mobileOptionBar.offsetHeight + 8;
            }
        }

        if (status.detailContactBar) {
            let detailContactBar = document.getElementsByClassName('detail-contact-bar')?.[0];
            if (detailContactBar) {
                bottom += detailContactBar.offsetHeight;
            }
        }
        if (bottom > 0) return `${bottom}px`;
        return '';
    };

    const GetOnClick = (linkId) => {
        if (linkId != '') {
            switch (linkId) {
                case 'updatecookies':
                    showCookieConsentModal();
                    break;
                default:
                    break;
            }
        };

        return null;
    }

    return (
        <footer className='site-footer no-print' ref={ref}>
            <div className='footer-top-border'></div>
            <div className='footer-content' style={{ paddingBottom: getBottomPosition() }}>
                <div className='footer-row-1'>
                    <div className='footer-links'>
                        {props.ShowTopLinks && props.FooterLinks && props.FooterLinks.length > 0 && props.FooterLinks.map(link =>
                            <Fragment key={link.LinkURL}>
                                {link.LinkURL.startsWith('http') ?
                                    <a className='footer-link' href={link.LinkURL} target='_blank' aria-label={link.LinkText + ' ' + translator.translate('sandhills.opensinanewtab')} >{link.LinkText}</a> :
                                    <a className='footer-link' href={link.LinkURL} rel={link.LinkRelation ? link.LinkRelation : null}>{link.LinkText}</a>}
                            </Fragment>)}
                    </div>
                    <div className='social-media-links'>
                        {props.ShowSocialMediaNetworkLinks &&
                            <div className='media-row'>
                                {props.SocialMediaNetworkLinks && props.SocialMediaNetworkLinks.length > 0 && props.SocialMediaNetworkLinks.map(link =>
                                    <a key={link.LinkURL} href={link.LinkURL} className={'social-item ' + link.LinkText + '-img ' + iconClass} target='_blank'>
                                        <LazyLoadImage style={link.LinkText === "youtube" ? { width: '37px', height: '35px', marginLeft: '10px', marginTop: '5px' } : {}} src={link.ImgURL} className='social-image' alt={link.LinkText + " " + translator.translate("sandhills.companylogomediaid")} />
                                        <span className='visually-hidden'>{link.LinkText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}</span>
                                    </a>)}
                            </div>}
                    </div>
                    {props.FooterLogo &&
                        <div className='footer-logo'>
                            <img src={props.FooterLogo} alt="" />
                        </div>
                    }
                </div>
                <div className='footer-row-2'>
                    {props.ShowOtherLinks &&
                        <div className='other-links'>
                            {props.OtherFooterLinks && props.OtherFooterLinks.length > 0 && props.OtherFooterLinks.map(link => {
                                if (!link.LinkId || link.linkId == '') {
                                    return (<a key={link.LinkURL} className='footer-link' href={link.LinkURL} target={link.LinkTargetName} aria-label={link.LinkText + ' ' + translator.translate('sandhills.opensinanewtab')}>{link.ImgURL && <img src={link.ImgURL} alt={link.ImgAltText}></img>}{link.LinkText}</a>);
                                } else {
                                    return (<a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); GetOnClick(link.LinkId); } }} onClick={() => GetOnClick(link.LinkId)} className='footer-link'>{ link.LinkText}</a>);
                                }
                            })}
                       </div>}
                </div>
                <div className='footer-row-2 center'>
                    <span className='copyright'>{props.Copyright}</span>
                </div>
            </div>
        </footer>
    )
};

export default FooterView;
global.FooterView = FooterView; 